var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlockMod("scroll-down-animation") },
    [
      _c(
        "div",
        { class: _vm.bemElement("filter-container") },
        [
          _c("TheProductListColumnMode"),
          _vm._v(" "),
          _c(
            "button",
            {
              class: [_vm.bemElement("filters-button"), "btn"],
              on: { click: _vm.openFilters }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$msg("filters.quantity.text", "filters", [
                      _vm.appliedFiltersTextQuantity
                    ])
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.siblingMenu.length > 0
        ? _c("TheProductListSiblingMenu", {
            class: _vm.bemElement("sibling-menu"),
            attrs: {
              "sibling-menu": _vm.siblingMenu,
              "current-category": _vm.currentCategory,
              "is-view-all-view": _vm.isViewAllView
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }